/**
 * @module modules/json-source-sk
 * @description <h2><code>json-source-sk</code></h2>
 *
 * Displays buttons that, when pressed, retrieve and show the JSON file that
 * was ingested for the point in the trace identified by commit id and trace
 * id.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JSONSourceSk", {
    enumerable: true,
    get: function() {
        return JSONSourceSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _task = require("@lit/task");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _errorMessage = require("../errorMessage");
const _json = require("../json");
require("../../../elements-sk/modules/spinner-sk");
const _paramtools = require("../paramtools");
require("@material/web/button/outlined-button.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let JSONSourceSk = class JSONSourceSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    // Handle opening/closing the modal dialog based on state changes.
    updated(changedProperties) {
        if (changedProperties.has('_dialogOpen')) {
            if (this._dialogOpen) {
                if (!this.dialog.open) {
                    this.dialog.showModal();
                }
            } else {
                if (this.dialog.open) {
                    this.dialog.close();
                }
            }
        }
    }
    validTraceID() {
        return (0, _paramtools.validKey)(this.traceid);
    }
    _loadSource() {
        if (!this.validTraceID() || this.cid === -1) {
            return;
        }
        this._fetchParams = {
            isSmall: false
        };
        this._dialogOpen = true;
    }
    _loadSourceSmall() {
        if (!this.validTraceID() || this.cid === -1) {
            return;
        }
        this._fetchParams = {
            isSmall: true
        };
        this._dialogOpen = true;
    }
    _closeJsonDialog() {
        this._dialogOpen = false;
        this._fetchParams = null;
    }
    render() {
        return (0, _lit.html)`
      <div class="controls" ?hidden=${!this.validTraceID()}>
        <button class="view-source" @click=${this._loadSource}>View Json File</button>
        <button class="load-source" @click=${this._loadSourceSmall}>View Short Json File</button>
      </div>
      <dialog class="json-dialog">
        <button class="closeIcon" @click=${this._closeJsonDialog} aria-label="Close">
          <close-icon-sk></close-icon-sk>
        </button>

        ${this._fetchCommitDetailsTask.render({
            pending: ()=>(0, _lit.html)`<spinner-sk active class="spinner"></spinner-sk>`,
            complete: (json)=>{
                if (json === null) return _lit.nothing;
                return (0, _lit.html)`
              <div class="json-source">
                <pre>${json}</pre>
              </div>
            `;
            },
            error: ()=>(0, _lit.html)`<div class="error">Error loading JSON</div>`
        })}
      </dialog>
    `;
    }
    constructor(...args){
        super(...args);
        this.cid = (0, _json.CommitNumber)(-1);
        this.traceid = '';
        this._fetchParams = null;
        this._dialogOpen = false;
        this._fetchCommitDetailsTask = new _task.Task(this, {
            task: async ([params], { signal })=>{
                if (!params || !this.validTraceID() || this.cid === -1) {
                    // Return null or initial state if we shouldn't fetch yet
                    return null;
                }
                try {
                    const body = {
                        cid: this.cid,
                        traceid: this.traceid
                    };
                    let url = '/_/details/';
                    if (params.isSmall) {
                        url += '?results=false';
                    }
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body),
                        signal
                    });
                    const json = await (0, _jsonOrThrow.jsonOrThrow)(response);
                    return JSON.stringify(json, null, '  ');
                } catch (e) {
                    (0, _errorMessage.errorMessage)(e);
                    throw e;
                }
            },
            args: ()=>[
                    this._fetchParams
                ]
        });
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    }),
    _ts_metadata("design:type", typeof _json.CommitNumber === "undefined" ? Object : _json.CommitNumber)
], JSONSourceSk.prototype, "cid", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], JSONSourceSk.prototype, "traceid", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], JSONSourceSk.prototype, "_fetchParams", void 0);
_ts_decorate([
    (0, _decorators.state)()
], JSONSourceSk.prototype, "_dialogOpen", void 0);
_ts_decorate([
    (0, _decorators.query)('.json-dialog'),
    _ts_metadata("design:type", typeof HTMLDialogElement === "undefined" ? Object : HTMLDialogElement)
], JSONSourceSk.prototype, "dialog", void 0);
JSONSourceSk = _ts_decorate([
    (0, _decorators.customElement)('json-source-sk')
], JSONSourceSk);
